<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="npt_angulo_posicao" class="col-sm-2 control-label">Angulo (Entre 0 e 179):</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.npt_angulo_posicao" class="form-control input-sm" id="npt_angulo_posicao">
            </div>
            <label for="npt_tipo_envio" class="col-sm-2 control-label">Fila de Envio:</label>
            <div class="col-sm-4">
                <select v-model.number="config.npt_tipo_envio"  class="form-control" id="npt_tipo_envio" >
                    <option :value="0">FIFO - Crescente</option>
                    <option :value="1">LIFO - Decrescente</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="npt_intervalo_acionar_antifurto" class="col-sm-2 control-label">Tempo Acionamento Antifurto:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.npt_intervalo_acionar_antifurto" class="form-control input-sm" id="npt_intervalo_acionar_antifurto">
            </div>
            <label for="npt_intervalo_alerta_antifurto" class="col-sm-2 control-label">Tempo Alerta Antifurto:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.npt_intervalo_alerta_antifurto" class="form-control input-sm" id="npt_intervalo_alerta_antifurto">
            </div>
        </div>

        <div class="form-group">
            <label for="npt_tipo_envio" class="col-sm-2 control-label">Informação Adicional:</label>
            <div class="col-sm-3">
                <select v-model.number="config.npt_informacoes_adicionais"  class="form-control" id="npt_informacoes_adicionais" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="npt_jamming" class="col-sm-2 control-label">Detecção de Jammer:</label>
            <div class="col-sm-2">
                <select v-model="config.npt_jamming"  class="form-control" id="npt_jamming" >
                    <option value="0">Desabilitar</option>
                    <option value="1">Alerta</option>
                    <option value="2">Alerta com imobilizador</option>
                    <option value="3">Alerta com Buzzer</option>
                </select>
            </div>
            <label for="npt_distancia_detectar_jamming" class="col-sm-2 control-label">Distância detectar Jamming:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.npt_distancia_detectar_jamming" class="form-control input-sm" id="npt_distancia_detectar_jamming">
            </div>
            <label for="npt_tempo_detectar_jamming" class="col-sm-2 control-label">Tempo detercar Jamming:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.npt_tempo_detectar_jamming" class="form-control input-sm" id="npt_tempo_detectar_jamming">
            </div>
        </div>

        <div class="form-group">
            <label for="npt_sensibilidade_movimento" class="col-sm-2 control-label">Sensibilidade de Movimento:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.npt_sensibilidade_movimento" class="form-control input-sm" id="npt_sensibilidade_movimento">
            </div>
            <label for="npt_delay_detectar_movimento" class="col-sm-2 control-label">Tempo detectar Movimento:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.npt_delay_detectar_movimento" class="form-control input-sm" id="npt_delay_detectar_movimento">
            </div>
            <label for="npt_porcentagem_movimento" class="col-sm-2 control-label">Porcentagem de Movimento:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.npt_porcentagem_movimento" class="form-control input-sm" id="npt_porcentagem_movimento">
            </div>
        </div>

        <div class="form-group">
            <label for="npt_sensibilidade_ausencia_movimento" class="col-sm-2 control-label">Sensibilidade Sem Movimento:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.npt_sensibilidade_ausencia_movimento" class="form-control input-sm" id="npt_sensibilidade_ausencia_movimento">
            </div>
            <label for="npt_delay_ausencia_movimento" class="col-sm-2 control-label">Tempo detectar sem Movimento:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.npt_delay_ausencia_movimento" class="form-control input-sm" id="npt_delay_ausencia_movimento">
            </div>
            <label for="npt_porcentagem_sem_movimento" class="col-sm-2 control-label">Porcentagem sem Movimento:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.npt_porcentagem_sem_movimento" class="form-control input-sm" id="npt_porcentagem_sem_movimento">
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-4">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>

            <div class="col-sm-4">

            </div>
            <div class="col-sm-2">
                <!--
                <div class="dropup">
                    <button class="btn btn-xs btn-block btn-default dropdown-toggle" type="button" id="dropdownMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-list-alt"></i> AÇÕES
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuList">
                        <li>
                            <button @click="sendAll()" type="button" class="btn btn-xs btn-success">
                                <i class="fa fa-save"></i> ENVIAR COMANDOS PARA TODOS
                            </button>
                        </li>
                    </ul>
                </div>
                -->
            </div>
        </div>

    </form>
</template>
<script>
    import {Suntech} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "TempoSuntech",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendNovosParamentos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },
            sendAll () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração para todos?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendNovosParamentosAll(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
